// FILECONTENT_START src/common/components/Form/useDeepEffect.ts
import { isEqual } from "lodash";
import { useEffect, useRef } from "react";

export default function useDeepEffect(fn: Function, deps: any) {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);

  useEffect(() => {
    const isFirstEffect = isFirst.current;
    const isSame = prevDeps.current.every((obj: any, index: number) =>
      isEqual(obj, deps[index])
    );

    isFirst.current = false;
    prevDeps.current = deps;

    if (isFirstEffect || !isSame) {
      return fn();
    }
    // eslint-disable-next-line
  }, deps);
}

// FILECONTENT_END src/common/components/Form/useDeepEffect.ts